// src/api/axiosInstance.ts
import Axios from "axios";
var authConfig = {};
var configureSharedAPI = (config) => {
  AXIOS_INSTANCE.defaults.baseURL = config.baseUrl;
  if (config.auth) {
    authConfig = config.auth;
  }
};
var AXIOS_INSTANCE = Axios.create({
  // baseURL is set by configureShared() at app initialization
  withCredentials: false
});
var getSharedAuthHeaders = async () => {
  const headers = {};
  const token = await authConfig.getToken?.();
  if (token) {
    headers.Authorization = `Bearer ${token}`;
    headers["lasso-token"] = token;
  }
  const uid = await authConfig.getUid?.();
  if (uid) {
    headers["uid"] = uid;
  }
  return headers;
};
var getSharedBaseUrl = () => AXIOS_INSTANCE.defaults.baseURL ?? "";
AXIOS_INSTANCE.interceptors.request.use(
  async (config) => {
    config.headers.set(await getSharedAuthHeaders());
    return config;
  },
  (error) => Promise.reject(error)
);
AXIOS_INSTANCE.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);
var customInstance = (config, options) => {
  return AXIOS_INSTANCE({ ...config, ...options }).then(({ data }) => data);
};

export {
  configureSharedAPI,
  AXIOS_INSTANCE,
  getSharedAuthHeaders,
  getSharedBaseUrl,
  customInstance
};
//# sourceMappingURL=chunk-Y7KXQJM2.mjs.map